import { QueryEvent, QueryTicketDto } from '@restore/queries/queries.types';
import { FC, useMemo } from 'react';
import { Collapse } from '@dynamika-shared/ui/Collapse/Collapse';

type QueryBodyProps = {
  query: QueryTicketDto | null;
};

export const QueryBody: FC<QueryBodyProps> = ({ query }) => {
  const messages = useMemo(() => {
    return query?.messages?.find(m => m.event === QueryEvent.SUBMIT)?.message;
  }, [query]);

  const attachments = useMemo(() => {
    return (
      query?.messages
        ?.flatMap(m => m.attachments)
        ?.map(a => a.filename)
        ?.join(', ') || '-'
    );
  }, [query]);

  const recipientsDisplay = useMemo(() => {
    return (
      query?.recipients?.map(r => `${r.firstName} ${r.lastName}`)?.join(', ') ||
      '-'
    );
  }, [query]);

  return (
    <div className='w-full bg-white px-3 pb-3 border border-brightGray rounded-[12px]'>
      <Collapse
        open
        label={
          <h3 className='text-1824 font-medium p-1.5 w-full'>
            {query?.types?.join(', ') || '-'}
          </h3>
        }
        styles={{
          container: 'mt-[2.4rem] max-w-[100%]',
          content: 'transition-all duration-300 overflow-hidden',
          header: 'bg-body rounded-md p-[12px] h-[4.8rem] mb-[1.5rem]',
          iconBtn: 'w-3 h-3 rounded-full border bg-ghostWhite',
          icon: 'w-2 h-2',
        }}
      >
        <div className='px-1.5'>
          <h4 className='text-1624 font-semibold mt-3'>Description</h4>
          <p className='text-1624 text-black font-normal'>{messages}</p>
          <h4 className='text-1624 font-semibold mt-3'>Attachments</h4>
          <p className='text-1624 text-black font-normal'>{attachments}</p>
          <h4 className='text-1624 font-semibold mt-3'>Recipients</h4>
          <p className='text-1624 text-black font-normal'>
            {recipientsDisplay}
          </p>
        </div>
      </Collapse>
    </div>
  );
};
